import React from 'react';
import { RealAssetFields } from 'Views/Page/Content/Modal/Layouts/RealAsset/Layout/minimalFields';
import { FDStack } from '@facet-wealth/design';

export function RealAssetMetaLayout() {
  return (
    <FDStack direction="column" paddingY={1} spacing={2}>
      <RealAssetFields />
    </FDStack>
  );
}
